<template>
  <div class="page-moregame">
    <GameHeader
      class="game-header"
      ref="gameHeader"
      :isSignRed="sign_red_dot"
      :isMsgRed="notice_red_dot"
      :is-top.sync="isTop"
    ></GameHeader>
    <div>
      <transition>
        <keep-alive>
          <router-view></router-view>
        </keep-alive>
      </transition>
    </div>

    <van-popup lock-scroll class="actPopup" v-model="showActivityPopup">
      <div class="content-con">
        <img src="@/assets/images/img-actDialog.png" class="mainImg" alt="" />
        <div class="text-content">
          <p v-if="act_notice.content" v-html="act_notice.content">
          </p>
        </div>
           <img
            class="skipBtn"
            v-if="act_notice.content&&act_notice.skip"
            src="@/assets/images/img-join.png"
            @click="toSkipJump(+act_notice.skip)"
            alt=""
          />
        <img
          class="closeImg"
          src="@/assets/images/tip-close.png"
          alt=""
          @click="showActivityPopup = ''"
        />
      </div>
    </van-popup>
    <van-popup lock-scroll class="msgPopup" v-model="showMsgPopup">
      <div class="content-con">
        <img src="@/assets/images/img-actDialog.png" class="mainImg" alt="" />
        <div class="text-content">
          <p v-if="msg_notice.content" v-html="msg_notice.content">
          </p>
        </div>
        <img
          class="closeImg"
          src="@/assets/images/tip-close.png"
          alt=""
          @click="showMsgPopup = ''"
        />
      </div>
    </van-popup>
    <van-popup class="imgPopup" v-model="showFestivalPopup"> 
      <div class="content-con">
        <img v-if="festival.image"
          :src="festival.image"
          @click="toSkipJump(+festival.skip)"
          class="mainImg"
          alt=""
        />
        <img
          class="closeImg"
          src="@/assets/images/tip-close.png"
          alt=""
          @click="showFestivalPopup = ''"
        />
      </div>
    </van-popup>
        <img v-if="isShowFloat" @click="showNewPersonHandle" src="@/assets/images/newManPack.png" alt=""
             style="position: fixed;bottom: 43%;right: 15px;width: 60px;">
    <van-popup class="imgPopup" v-model="showNewPersonPopup" style="width: 100%;">
      <div class="content-con">
        <img
          v-if="newPerson.image"
          :src="newPerson.image"
          class="mainImg"
          alt=""
          @click="getNewManPack"
        />
      </div>
    </van-popup>
    <van-popup class="imgPopup" v-model="getNewManPackPopup" style="width: 100%;">
      <div class="content-con" style="margin-left: 0.8rem;padding-top: 40px;width: auto;">
        <img
                class="closeImg"
                src="@/assets/images/tip-close.png"
                style="margin-right: 1rem;"
                alt=""
                @click="getNewManPackPopup = false"
        />
        <div style="width: 80vw;height: auto;background: white;border-radius: 5vw;font-size: 13px;line-height: 13px;">
          <span style="font-weight: 600;font-size: 18px;width: 100%;text-align: center;display: inline-block;margin-top: 15px;">领取成功</span>
          <span style="font-weight: 600;font-size: 15px;width: 100%;;display: inline-block;margin-top: 15px;margin-bottom: 5px;padding-left: 20px;">获得奖励：</span>
          <span v-for="(item,index) in awardList" :key="index" style="font-weight: 600;font-size: 13px !important;width: 100%;;display: inline-block;margin-top: 3px;padding-left: 20px;">
            {{index+1}}、<span style="color: #56B7BD;">{{item}}</span>
          </span>
          <span style="font-weight: 600;font-size: 12px;width: 100%;text-align: center;display: inline-block;margin-top: 15px;">快去参加新人任务，获取更多丰厚奖励吧！</span>
          <span style="width: 100px;line-height:28px;border-radius: 15px;font-weight: 600;font-size: 16px;text-align: center;display: inline-block;margin-top: 15px;color: white;background: #56B7BD;margin-left: calc(50% - 50px);
          margin-bottom: 10px;" @click="toSkipJump(+newPerson.skip)">去参与</span>
        </div>
      </div>
    </van-popup>
    <van-popup class="vipPopup" v-model="showVipPopup">
      <div class="content-con">
        <div class="content" v-if="vip_up.content">
          <h3>{{ vip_up.title }}</h3>
          <div class="content-scroll">
          <p class="p1">{{ vip_up.sub_title }}</p>
          <p class="p2" v-for="(item, index) in vip_up.content" :key="index">
             {{ index + 1 }}. {{ item }}
          </p>
          </div>
          <img
            v-if="vip_up.content"
            class="btn-get"
            src="@/assets/images/btn-getNow.png"
            @click="getVipGetTicketData"
            alt=""
          />
        </div>
        <img
          class="closeImg"
          src="@/assets/images/tip-close.png"
          alt=""
          @click="showVipPopup = ''"
        />
      </div>
    </van-popup>
    <van-popup class="vipPopup" v-model="showSendPopup">
      <div class="content-con">
        <div class="content" v-if="send_up.content">
          <h3>{{ send_up.title }}</h3>
          <div class="content-scroll">
            <p class="p2" v-if="send_up.content" v-html="send_up.content">
            </p>
          </div>
          <img
                  v-if="send_up.content"
                  class="btn-get"
                  src="@/assets/images/lookNow.png"
                  @click="goToSendPage(send_up.skip)"
                  alt=""
          />
        </div>
        <img
                class="closeImg"
                src="@/assets/images/tip-close.png"
                alt=""
                @click="showSendPopup = false"
        />
      </div>
    </van-popup>
  </div>
</template>
<script>
  import GameHeader from "@/components/GameHeader/index.vue";
  import { reqHomePopupData, reqVipGetTicketData, getNewManPackData } from "@/api/moregame";
  import { Toast } from "vant";
  export default {
    name: "moreGame",
    data() {
      return {
        isTop: true,
        isNormal: false,
        isShowNew: false,
        isShowFloat: false,
        getNewManPackPopup: false,
        showNewPersonPopup: false,
        sign_red_dot: 0,
        notice_red_dot: 0,
        newPerson: {},
        festival: {},
        msg_notice: {},
        act_notice: {},
        vip_up: {},
        send_up: {},
        showSendPopup: false,
        awardList: [],
        // awardList: ["通用代金券无门槛4元代金券*1",
        //   "绝世萌仙满10元9.7折代金券*2",
        //   "20积分",
        //   "10平台币"]
      };
    },
    components: {
      GameHeader,
    },
    watch: {
      "$route.path"(val) {
          this.$refs.gameHeader.freshTabStatus();
      },
    },
    methods: {
      scrollHandler(e){
        if (this.isTop && window.pageYOffset > 240) {
          this.isTop = false
          this.$emit('update:item', this.isTop)
        } else if (!this.isTop && window.pageYOffset < 240) {
          this.isTop = true
          this.$emit('update:item', this.isTop)
        }
      },
      async getNewManPack(){
        try {
           if(!this.isNormal) {
             const re = await getNewManPackData();
             this.awardList = re.award;
             this.isShowFloat = false;
             this.showNewPersonPopup = false;
             this.getNewManPackPopup = true
           }else{
             this.toSkipJump(+this.newPerson.skip)
           }
        } catch (error) {
         //console.log(error, "getHomePopupData");
        }
      },
      showNewPersonHandle(){
        this.showNewPersonPopup = true;
      },
      async getHomePopupData() {
        try {
          const re = await reqHomePopupData();
          this.sign_red_dot = re.sign_red_dot;
          this.notice_red_dot = re.notice_red_dot;
          this.newPerson = re.new;
          this.isNormal = this.newPerson.type == 5
          // this.newPerson = {
          //   "image": "https://material.gameyiming.com/images/5abadf3f83f417b800ca019f7e1bf03a",
          //   "skip": 1
          // }
          this.festival = re.festival;
          this.msg_notice = re.msg_notice;
          this.act_notice = re.act_notice;
          this.vip_up = re.vip_up;
          this.send_up = re.send_up;
          if(this.send_up?.skip){
            this.showSendPopup = true
          }
          this.isShowFloat = re.is_show_float == 1
          this.showNewPersonPopup = re.is_show_new == 1;
          // console.log(re, "getHomePopupData");
        } catch (error) {
          //console.log(error, "getHomePopupData");
        }
      },
      toSkipJump(skip) {
        switch (skip) {
          case 1:
            sessionStorage.setItem('newPersonTaskFromPath','moreGame')
            this.$router.push({name:'newPersonTask'});
            this.showActivityPopup = false;
            this.showMsgPopup = false;
            this.showFestivalPopup = false;
            this.showNewPersonPopup = false;
            this.showVipPopup = false;
            break;
          case 2:
            sessionStorage.setItem('taskCenterFromPath','moreGame')
            this.$router.push({name:'taskCenter'});
            this.showActivityPopup = false;
            this.showMsgPopup = false;
            this.showFestivalPopup = false;
            this.showNewPersonPopup = false;
            this.showVipPopup = false;
            break;
          case 3:
            sessionStorage.setItem('hotActivityFromPath','moreGame')
            this.$router.push({name:'hotActivity'});
            this.showActivityPopup = false;
            this.showMsgPopup = false;
            this.showFestivalPopup = false;
            this.showNewPersonPopup = false;
            this.showVipPopup = false;
            break;
          case 4:
            this.$router.push({name:'game'});
            this.showActivityPopup = false;
            this.showMsgPopup = false;
            this.showFestivalPopup = false;
            this.showNewPersonPopup = false;
            this.showVipPopup = false;
            break;
          case 5:
            this.$router.push({name:'wActivity'});
            this.showActivityPopup = false;
            this.showMsgPopup = false;
            this.showFestivalPopup = false;
            this.showNewPersonPopup = false;
            this.showVipPopup = false;
            break;
          default:
            break;
        }
      },
      async getVipGetTicketData() {
         console.log("点击领取了", "getVipGetTicketData");
        try {
          const re = await reqVipGetTicketData();
          console.log(re, "getVipGetTicketData");
          Toast("领取成功");
          this.showVipPopup = false;
        } catch (error) {
          Toast(error);
          this.showVipPopup = false;
          // console.log(error, "getVipGetTicketData");
        }
      },
      goToSendPage(skip){
        // skip 6-我的平台币   7-我的积分 8-我的代金券
        switch (skip) {
          case 6:
            sessionStorage.setItem('coinDetailFromPath','recommend')
            this.$router.push({name:'coinDetail'})
            break;
          case 7:
            sessionStorage.setItem('ecardDetailFromPath','recommend')
            this.$router.push({name:'ecardDetail'})
            break;
          case 8:
            sessionStorage.setItem('myVoucherFromPath','recommend')
            this.$router.push({name:'myVoucher'})
            break;
        }
        this.showSendPopup = false;
      }
    },
    computed: {
      showFestivalPopup: {
        get() {
          if (this.festival.image) {
            return true;
          } else {
            return false;
          }
        },
        set(val) {
          this.festival.image = val;
        },
      },
      showActivityPopup: {
        get() {
          if (this.act_notice.content) {
            return true;
          } else {
            return false;
          }
        },
        set(val) {
          this.act_notice.content = val;
        },
      },
      showMsgPopup: {
        get() {
          if (this.msg_notice.content) {
            return true;
          } else {
            return false;
          }
        },
        set(val) {
          this.msg_notice.content = val;
        },
      },
      showVipPopup: {
        get() {
          if (this.vip_up.content) {
            return true;
          } else {
            return false;
          }
        },
        set(val) {
          this.vip_up.content = val;
        },
      },
    },
    mounted() {
      this.getHomePopupData();
      window.addEventListener('scroll', this.scrollHandler);
    },
    beforeDestroy(){
      window.removeEventListener('scroll', this.scrollHandler);
    },
  };
</script>

<style lang="scss" scoped>
  .page-moregame {
    width: 100%;
    height: 100%;
    position: relative;
    .game-header {
      position: fixed;
      top: 0;
      left: 0;
      z-index: 1000;
    }

    ::v-deep .actPopup {
      width: 70%;
      background: transparent;
      .content-con {
        width: 100%;
        height: 100%;
        position: relative;
        background: transparent;
        .mainImg {
          width: 100%;
          height: calc(100% - 15px);
        }
        .text-content {
          width: 100%;
          height: 80%;
          position: absolute;
          left: 0px;
          top: 100px;
          display: flex;
          flex-direction: column;
          align-items: center;
          h2 {
            font-size: 54px;
            font-weight: normal;
            font-style: italic;
            color: yellow;
            line-height: 68px;
            text-shadow: 0px 4px 3px #b31e10;
          }
          p {
            height: calc(100% - 250px);;
            width: 426px;
            margin-top: 75px;
            font-size: 28px;
            font-weight: 500;
            color: #272727;
            line-height: 36px;
            word-wrap: break-word;
            overflow: scroll;
          }
        }
         .skipBtn {
            width: 296px;
            height: 96px; 
          position: absolute;
          left: 50%;
          bottom: 7%;
          transform: translate(-50%);
          }
        .closeImg {
          width: 42px;
          height: 42px;
          position: absolute;
          right: 10px;
          top: 0px;
        }
      }
    }
    ::v-deep .msgPopup {
      width: 70%;
      background: transparent;
      .content-con {
        width: 100%;
        height: 100%;
        position: relative;
        background: transparent;
        .mainImg {
          width: 100%;
        }
        .text-content {
          width: 100%;
          height: 80%;
          position: absolute;
          left: 0px;
          top: 100px;
          display: flex;
          flex-direction: column;
          align-items: center;
          h2 {
            font-size: 54px;
            font-family: zihun164hao;
            font-weight: normal;
            font-style: italic;
            color: yellow;
            line-height: 68px;
            text-shadow: 0px 4px 3px #b31e10;
          }
          p {
             height: calc(100% - 190px);;
            width: 426px;
            margin-top: 85px;
            font-size: 28px;
            font-weight: 500;
            color: #272727;
            line-height: 36px;
            word-wrap: break-word;
            overflow: scroll;
          }
        }
        .closeImg {
          width: 42px;
          height: 42px;
          position: absolute;
          right: 10px;
          top: 0px;
        }
      }
    }
    ::v-deep .imgPopup {
      width: 70%;
      background: transparent;
      .content-con {
        width: 100%;
        height: 100%;
        position: relative;
        background: transparent;
        .mainImg {
          width: 100%;
          height: calc(100% - 15px);
        }
        .closeImg {
          width: 42px;
          height: 42px;
          position: absolute;
          right: 10px;
          top: 0px;
        }
      }
    }
    ::v-deep .vipPopup {
      width: 630px;
      height: 766px;
      background: transparent;
      .content-con {
        width: 630px;
        height: 756px;
        background: transparent;
        position: relative;
        padding-top: 100px;
       
        .content {
          display: flex;
          flex-direction: column;
          align-items: center;
          padding: 0 30px;
          background: linear-gradient(0deg, #FFF, #FFF);
          border-radius: 40px;
          width: 630px;
          height: 646px;
          
          h3 {
            font-size: 36px;
            font-weight: bold;
            color: #272727;
            margin-top: 36px;
          }
          .content-scroll{
            width: 630px;
            height: calc(100% - 240px);
            padding: 0 30px;
            margin-top: 45px;
            overflow: scroll;
            .p1 {
            width: 100%;
            text-align: left;
            font-size: 30px;
            font-weight: bold;
            color: #272727;
            margin-bottom: 36px;
            }
            .p2 {
            width: 100%;
            text-align: left;
            font-size: 28px;
            font-weight: bold;
            color: #272727;
            line-height: 40px;
            word-wrap: break-word;
            }
          }
      
        }
        .btn-get {
            width: 241px;
            height: 61px;
            position: absolute;
            left: 50%;
            transform: translate(-50%);
            bottom:50px;
          }
        .closeImg {
            width: 42px;
            height: 42px;
            position: absolute;
            right: 5px;
            top: 5px;
        }
      }
    }
  }
</style>
